import "hammerjs";
import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Router } from "@angular/router";

import { AppModule } from "./app/core/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then((moduleRef) => {
    // Router's initialNavigation is disabled (see app.routing.module.ts) so it doesn't race
    // against navigations triggered by AppInitService's APP_INITIALIZER (e.g. EHR SMART
    // launch's redirect to /landing). Trigger it manually now that APP_INITIALIZERs, and any
    // navigation they kicked off, have fully resolved.
    moduleRef.injector.get(Router).initialNavigation();
  })
  .catch((err) => console.error(err));
